import { UAParser } from 'ua-parser-js';

export function describeDevice(): string {
  const parser = new UAParser();
  return `${parser.getBrowser().name} ${parser.getOS().name}`;
}
